var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/directional/down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5932es7u0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/down (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/down (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/down",
    style: {
      clipPath: "url(#5932es7u0a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/down (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/down (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.812 4H12.64a.251.251 0 0 0-.2.1L8 10.222 3.562 4.1a.251.251 0 0 0-.2-.1H2.187a.125.125 0 0 0-.1.2l5.509 7.6a.5.5 0 0 0 .808 0l5.508-7.6a.124.124 0 0 0-.1-.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.84e6709cc9a335de8d8ac74e78b90dfb.svg";
export { ForwardRef as ReactComponent };